import { doc, getDoc } from "firebase/firestore";
import React, { useEffect, useState, useCallback } from "react";
import { db } from "../../../features/firebase";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading/Loading";
import { Helmet } from "react-helmet-async";
import InputStepOne from "./Section/InputStepOne";
import "./Inputpage.scss";
import Stepper from "../../components/Stepper/Stepper";
// import DatePickerID from "../../components/DatePicker/DatePicker";

const Inputpage = ({ user }) => {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(async () => {
    if (!user) {
      navigate("/login");
      return;
    }

    setIsLoading(true);
    try {
      const uid = user.uid;
      const docRef = doc(db, "registered", uid);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        const userState = { unregistered: true };
        navigate("/registrasi-profil", { state: userState });
      }
    } catch (error) {
      console.error("Error fetching document: ", error);
    } finally {
      setIsLoading(false);
    }
  }, [navigate, user]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <main className="input-newmem-page">
      <Helmet>
        <title>KIRMAGO | Registrasi Anggota</title>
      </Helmet>
      {isLoading && <Loading />}
      {/* <DatePickerID /> */}
      {/* <p>this is inputpage {isLoading ? "true" : "false"}</p> */}
      <div className="input-newmem-box">
        <InputStepOne />
        <Stepper step={step} />
        <button onClick={() => setStep(step - 1)}>before</button>
        <button onClick={() => setStep(step + 1)}>next</button>
      </div>
    </main>
  );
};

export default Inputpage;
